<template>
  <div>
    <div v-if="isEditing">
      <FilterableDropdown
        v-if="showLabel"
        :autofocus="autofocus"
        textLabel="Trip Type"
        size="sm"
        v-model="trip.tripType"
        :options="tripTypes"
        :clearable="false"
        :searchable="true"
        placeholder="Trip Type"
        class="uk-padding-remove-left uk-padding-remove-right uk-form-width-small"
      />
      <FilterableDropdown
        v-else
        :autofocus="autofocus"
        size="sm"
        v-model="trip.tripType"
        :options="tripTypes"
        :clearable="false"
        :searchable="true"
        placeholder="Trip Type"
        class="uk-padding-remove-left uk-padding-remove-right uk-form-width-small"
      />
    </div>
    <div v-else class="tw-flex tw-items-center tw-gap-2">
      <InProgressIcon
        v-if="trip.status == 'In Progress'"
        title="Trip is in Progress"
        class="tw-h-4 tw-w-4 tw-text-emerald-600"
      />
      <CheckmarkFilled
        v-else-if="trip.status == 'Complete'"
        title="Trip complete"
        class="tw-h-4 tw-w-4 tw-text-emerald-700"
      />
      <CircleDashed
        v-else
        title="Trip not started"
        class="tw-h-4 tw-w-4 tw-text-slate-400"
      />

      <span
        v-if="trip.tripType"
        class="tw-inline-flex tw-items-center tw-rounded-md tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold"
        :class="
          gray
            ? 'tw-bg-slate-100 tw-text-slate-700'
            : red
              ? 'tw-bg-rose-100 tw-text-rose-800'
              : darkGreen
                ? 'tw-bg-emerald-100 tw-text-emerald-800'
                : green
                  ? 'tw-bg-emerald-100 tw-text-emerald-800'
                  : 'tw-bg-slate-100 tw-text-slate-700'
        "
      >
        {{ trip.tripType }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { TripTypesList } from '@/lib/trips';
import InProgressIcon from '@carbon/icons-vue/es/in-progress/24';
import CircleDashed from '@carbon/icons-vue/es/circle-dash/24';
import CheckmarkFilled from '@carbon/icons-vue/es/checkmark--filled/24';
import FilterableDropdown from '../../core/FilterableDropdown.vue';

export default defineComponent({
  props: [
    'trip',
    'isEditing',
    'autofocus',
    'showLabel',
    'red',
    'gray',
    'green',
    'darkGreen',
  ],
  components: {
    FilterableDropdown,
    InProgressIcon,
    CheckmarkFilled,
    CircleDashed,
  },
  data(): any {
    return {
      tripTypes: TripTypesList,
    };
  },
});
</script>

<style scoped>
svg {
  vertical-align: middle;
}
</style>